import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";
import AuthPending from "./AuthPending";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth();

  // Waiting rather than redirecting: sending somebody away while the session is still being read
  // would throw a signed-in user off the page they opened. The same component as on the start
  // page, so one state has one wording wherever the wait happens.
  if (loading) return <AuthPending />;

  if (!isAuthenticated) return <Navigate to="/" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
